const {
  SET_CONTENT_KEY,
  SET_MAIN_KEY,
  SET_CONTENT_KEY_G,
  SET_SIDE_TAB_KEY,
  SET_SIDE_TAB_KEY_G,
  SET_UNDERLINE_KEY,
} = require("../actions/actiontypes");

const initState = {
  contentKey: "",
  contentKeyG: "",
  mainKey: "",
  sideTabKey: "",
  sideTabKeyG: "",
  underlineKey: "0",
};

const otherReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_CONTENT_KEY:
      return {
        ...state,
        contentKey: action.key,
      };
    case SET_CONTENT_KEY_G:
      return {
        ...state,
        contentKeyG: action.key,
      };
    case SET_MAIN_KEY:
      return {
        ...state,
        mainKey: action.key,
      };
    case SET_SIDE_TAB_KEY:
      return {
        ...state,
        sideTabKey: action.key,
      };
    case SET_SIDE_TAB_KEY_G:
      return {
        ...state,
        sideTabKeyG: action.key,
      };
    case SET_UNDERLINE_KEY:
      return {
        ...state,
        underlineKey: action.key,
      };

    default:
      return state;
  }
};

export default otherReducer;
